var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header2"},[_c('div',{staticClass:"box2 cf"},[_c('a',{staticClass:"logo fl dpb",attrs:{"href":_vm.protocolUrl+'//'+_vm.hostnameUrl}},[_c('img',{attrs:{"src":_vm.logoUrl}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2146598a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/headers/index.vue
// module id = null
// module chunks = 